import { Card, CardContent, Typography, Divider, CardActions, Button, Chip, Stack, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { AxiosInstance } from '../../api/apiInstance';
import { IOrderBaskets } from '../../interface/IOrders_Tasks';
import { useParams } from 'react-router-dom';

export interface OrderChatProps {
    singleOrderData: any;
    setSingleOrderData: (dt: any) => void;    
}
function OrderChat(props: OrderChatProps) {

    // order-basket/findByOrder/67D4B8DD-5EA0-EF11-9F6E-5CC5D4460392'
    const {singleOrderData,  setSingleOrderData } = props
    let { orderData } = useParams();    
    const [showSave, setShowSave] = useState<boolean>(true);

    
    
    function saveOrderNote(e:any)
    {
        const tmpOrder = { ...singleOrderData }
        tmpOrder.orderNote = e;
        setSingleOrderData(tmpOrder);
    }

    const handleSave = async () => {
        const tmp = {
            orderNote: singleOrderData.orderNote,
        }
        await AxiosInstance.patch('order/updateData/' + orderData, tmp)
            .then(function (response) {
            })
            .catch(function (error) {
                console.log(error);
            });
            setShowSave(!showSave);
    };

    return (
        <Card sx={{ minWidth: 440, height: 240  }}>

            <Typography component="div" variant="h5">
            Internal Chat
            </Typography>
            <Divider />
            <CardContent sx={{  minHeight: 110  }}>
                <TextField
                    style={{ paddingLeft: '.5rem', width: '100%' }}
                    autoComplete='off'                    
                    id="filled-multiline-flexible"
                    multiline
                    disabled = {showSave}
                    maxRows={3}
                    rows={3}
                    
                    variant="outlined"
                    value={singleOrderData.orderNote}
                    onChange={(e) => { saveOrderNote(e.target.value) }}
                />

            </CardContent>
            <Divider />
            <CardActions>
                {showSave ?
                <Button
                    //variant="contained"             
                    size='small'
                    variant="outlined"
                    onClick={()=>{setShowSave(!showSave)}}>Update</Button>
                    : <>
                    <Button
                    //variant="contained"             
                    size='small'
                    variant="outlined"
                    onClick={handleSave}>save</Button>
                    <Button
                    //variant="contained"  
                    variant="outlined"           
                    size='small'
                    onClick={()=>{setShowSave(!showSave)}}>cancel</Button>
                    </>
                }
            </CardActions>
        </Card>
    )
}

export default OrderChat
